// src/translations/es.js
const es = {
  header: {
    home: 'Inicio',
    services: 'Servicios',
    aboutUs: 'Nosotros',
    contact: 'Contacto',
  },
  footer: {
    contactUs: 'Contáctanos',
    quickLinks: 'Enlaces Rápidos',
    ourMission: 'Nuestra Misión',
    missionText: 'Empoderando a personas y negocios a través de soluciones financieras integrales.',
    allRightsReserved: 'Todos los derechos reservados.',
  },
  home: {
    hero: {
      title: 'Tu Camino Hacia el Éxito Financiero Comienza Aquí',
      subtitle: 'Empoderando a individuos y empresas con soluciones financieras integrales para el crecimiento y la estabilidad.',
      button: 'Comienza Hoy',
      businessPlanButton: 'Ver Nuestras Soluciones',
    },
    services: {
      title: 'Nuestros Servicios Principales',
      corporateTaxes: {
        title: 'Impuestos para Corporaciones y LLC',
        description:
          'Preparamos de forma estratégica tus declaraciones 1120, 1120-S y 1065, con enmiendas, extensiones y acompañamiento durante todo el año para que tu empresa esté protegida frente al IRS.',
      },
      personalTaxes: {
        title: 'Impuestos Personales y Pequeños Negocios',
        description:
          'Declaraciones 1040, enmiendas, extensiones, ITIN (W-7) y cartas del IRS explicadas para que presentes con confianza y sin sorpresas.',
      },
      businessCreditProfile: {
        title: 'Perfil de Crédito Empresarial',
        description:
          'Construimos contigo un perfil de crédito que el sistema sí ve: DUNS, cuentas con proveedores que reportan y presencia profesional que abre puertas.',
      },
      capitalMap: {
        title: 'Mapa de Capital',
        description:
          'Analizamos tus números y tu estructura para diseñar 2–3 rutas reales de capital para tu negocio, alineadas con tus metas.',
      },
      financialEducation: {
        title: 'Educación Financiera para Préstamos',
        description:
          'Te explicamos cómo piensan los prestamistas para que dejes de pedir dinero a ciegas y empieces a solicitar capital con estrategia.',
      },
      businessRegistration: {
        title: 'Registro de Empresas',
        description: 'Formaliza tu negocio para el crecimiento y beneficios legales.',
      },
      businessFinancing: {
        title: 'Financiamiento Empresarial',
        description: 'Accede a capital para impulsar la expansión de tu negocio.',
      },
      microcredits: {
        title: 'Microcréditos',
        description: 'Préstamos flexibles para necesidades personales o pequeños negocios.',
      },
    },
    problems: {
      title: 'Soluciones Reales para Desafíos Reales',
      capitalLack: {
        title: 'Falta de Capital para el Crecimiento',
        description: '¿Necesitas invertir en publicidad o personal? Te ayudamos a conseguir el capital para impulsar tus ventas.',
      },
      informalBusiness: {
        title: 'Operaciones Comerciales Informales',
        description: 'Ofrecemos microcréditos para cubrir registro legal, licencias y asesoramiento, formalizando tu negocio.',
      },
      substandardPremises: {
        title: 'Locales Comerciales Inadecuados',
        description: 'Financiamiento para renovar tu local y aumentar el tráfico de clientes.',
      },
      insufficientCashFlow: {
        title: 'Flujo de Caja Insuficiente',
        description: 'Líneas de crédito para mantener tus operaciones sin detener producción ni ventas.',
      },
    },
    cta: {
      title: '¿Listo para Transformar tu Futuro Financiero?',
      subtitle: 'Contáctanos hoy para un plan personalizado y soluciones claras.',
      button: 'Contáctanos Ahora',
    },
  },

  services: {
    hero: {
      title: 'Nuestras Soluciones Financieras Integrales',
      subtitle: 'Servicios diseñados para crecimiento, estabilidad y acceso a capital.',
    },
  },

  // 🔥🔥🔥 NUEVA SECCIÓN AGREGADA — PAQUETES & PRECIOS 🔥🔥🔥
  pricing: {
    title: 'Paquetes y Precios',
    subtitle: 'Programa Fractional CFO de 12 meses para emprendedores y pequeñas empresas.',
    plans: {
      starter: {
        badge: 'Plan Starter',
        price: '$3,500',
        per: '/año',
        forTitle: 'Diseñado para:',
        forText: 'Nuevos emprendedores o negocios en etapa temprana.',
        objectiveTitle: 'Objetivo:',
        objectiveText: 'Crear estructura financiera y presencia empresarial.',
        includesTitle: 'Incluye:',
        includes: [
          'Soporte básico de formalización empresarial',
          'Inicio de crédito empresarial',
          'Perfil empresarial básico (sitio web, email corporativo y teléfono)',
          'Impuestos: Formulario 1040 + Schedule C + extensiones + estatal si aplica',
          'Educación y soporte financiero mensual'
        ],
        resultsTitle: 'Resultados esperados:',
        results: [
          'Negocio estructurado',
          'Inicio del camino PAYDEX',
          'Base para futuras solicitudes de capital'
        ]
      },
      growth: {
        badge: 'Plan Growth',
        price: '$5,500',
        per: '/año',
        forTitle: 'Diseñado para:',
        forText: 'Negocios con ingresos que requieren organización financiera y fiscal.',
        objectiveTitle: 'Objetivo:',
        objectiveText: 'Organizar contabilidad, reportes y estrategia fiscal.',
        includesTitle: 'Incluye todo en Starter, más:',
        includes: [
          'Bookkeeping mensual (QuickBooks)',
          'Pérdidas y Ganancias, Balance General y Flujo de Efectivo básico',
          'Planificación fiscal y optimización de deducciones',
          'Expansión de crédito empresarial y monitoreo PAYDEX'
        ],
        resultsTitle: 'Resultados esperados:',
        results: [
          'Dueño entiende los números del negocio',
          'Menor carga fiscal dentro de la ley',
          'Reportes listos para solicitudes de capital'
        ]
      },
      expansion: {
        badge: 'Plan Expansion',
        price: '$7,500',
        per: '/año',
        forTitle: 'Diseñado para:',
        forText: 'Negocios que buscan escalar y obtener capital.',
        objectiveTitle: 'Objetivo:',
        objectiveText: 'Preparar el negocio para financiamiento comercial y crecimiento.',
        includesTitle: 'Incluye todo en Growth, más:',
        includes: [
          'Mapa de Capital (2–3 rutas de financiamiento)',
          'Pre-underwriting para bancos y SBA',
          'Paquete bancario y proyecciones',
          'Compensación del dueño y estrategia fiscal avanzada',
          'Gestión de crédito empresarial para construir historial'
        ],
        resultsTitle: 'Resultados esperados:',
        results: [
          'Elegibilidad para capital comercial',
          'Estructura financiera escalable',
          'Mayor poder de negociación con prestamistas'
        ]
      }
    }
  },

  about: {
    hero: {
      title: 'Acerca de San Jose Obrero LLC',
      subtitle: 'Tu socio de confianza en crecimiento financiero y estabilidad.',
    },
  },

  contact: {
    hero: {
      title: 'Ponte en Contacto',
      subtitle: 'Estamos aquí para ayudarte a alcanzar tus metas financieras.',
    },
  },

  whatsapp: {
    defaultMessage: 'Hola, me gustaría saber más sobre sus servicios.',
  },
};

export default es;
